export default "__VITE_ASSET__DGivuxwX__"